import { useDisclosure } from "@mantine/hooks"
import { notifications } from "@mantine/notifications"
import { Button } from "@tfg/ui"

import { queryClient } from "~/backend/queryClient"
import { useAnonymizeUser } from "~/gen/api"
import { AnonymizeUserModal } from "~/pages/Admin/Organizations/AnonymizeUserButton/AnonymizeUserModal"

type AnonymizeUserButtonProps = {
  organizationId: number
  user: {
    id: string
    email: string
    name: string
  }
}

const NOTIFICATIONS = {
  SUCCESS: {
    autoClose: 10000,
    styles: {
      description: {
        maxHeight: "unset",
        height: "min-content",
        textOverflow: "unset",
      },
    },
    message: `User anonymized`,
    color: "green",
  },
  ERROR: {
    title: "Error",
    message: "An error occurred while anonymizing the user",
    color: "red",
  },
}

export const AnonymizeUserButton = ({
  organizationId,
  user,
}: AnonymizeUserButtonProps) => {
  const { mutate: anonymizeUser } = useAnonymizeUser(user.id, {
    mutation: {
      onSuccess: () => {
        notifications.show(NOTIFICATIONS.SUCCESS)
        queryClient.invalidateQueries(["organizations", organizationId])
        return true
      },
      onError: () => {
        notifications.show(NOTIFICATIONS.ERROR)
      },
    },
  })
  const [opened, { open, close }] = useDisclosure(false)

  return (
    <>
      <AnonymizeUserModal
        opened={opened}
        close={close}
        handleAnonymizeUser={() => anonymizeUser(undefined as never)}
        userName={user.name}
      />
      <Button
        size="sm"
        variant="secondary"
        fullWidth={false}
        data-user-email={user.email}
        data-testid="anonymize-user"
        onClick={open}
      >
        Anonymize
      </Button>
    </>
  )
}
